<template>
<div>
    <div>
        <el-card>
          <div>
             ACS待提现金额: <span style="color:red"> {{ (queryArr.balance / 100).toFixed(2) }}&emsp;</span>
          </div>
           <div>
             平台余额:
             总额<span style="color:red"> {{ (platformBalance.allAmount / 100).toFixed(2) }}&emsp;</span>
           </div>
           <div>
             可提现余额<span style="color:red"> {{ (platformBalance.cloud_amount / 100).toFixed(2) }}&emsp;</span>
             已转账平台服务费<span style="color:red"> {{ (platformBalance.platform_paid_fee / 100).toFixed(2) }}&emsp;</span>
             已转账平台配送费<span style="color:red"> {{ (platformBalance.freight_paid_fee / 100).toFixed(2) }}&emsp;</span>
           </div>
            <div>
              不可提现余额<span style="color:red"> {{ (platformBalance.disable_amount / 100).toFixed(2) }}&emsp;</span>
              未转账平台服务费<span style="color:red"> {{ (platformBalance.platform_wait_fee / 100).toFixed(2) }}&emsp;</span>
              未转账平台配送费<span style="color:red"> {{ (platformBalance.freight_wait_fee / 100).toFixed(2) }}&emsp;</span>
            </div>

            <el-button type="primary" @click="dialogFormVisible = true" size="mini">点击提现</el-button>
        </el-card>
        <el-row :gutter="24">
            <el-col :span="6">
                <el-date-picker size="mini" v-model="params.times" type="daterange"
                    :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" align="right">
                </el-date-picker>
            </el-col>
            <el-col :span="5">
               <el-button type="primary" @click="searchData()" size="mini">根据时间获取金额</el-button>
            </el-col>

        </el-row>
        <el-card v-if="platformlist.cloud_amount !=undefined">
        <div>
          已转账平台服务费<span style="color:red"> {{ (platformlist.platform_paid_fee / 100).toFixed(2) }}&emsp;</span>
          已转账平台配送费<span style="color:red"> {{ (platformlist.freight_paid_fee / 100).toFixed(2) }}&emsp;</span>
        </div>
         <div>
           未转账平台服务费<span style="color:red"> {{ (platformlist.platform_wait_fee / 100).toFixed(2) }}&emsp;</span>
           未转账平台配送费<span style="color:red"> {{ (platformlist.freight_wait_fee / 100).toFixed(2) }}&emsp;</span>
         </div>
        </el-card>
        <el-dialog title="提现" :visible.sync="dialogFormVisible" :before-close="handleClose">
            <el-form :model="form">
                <el-form-item label="提现金额">
                    <el-input v-model="form.amount" type="number" :rules="[
              { required: true, message: '金额不能为空' },
              { type: 'number', message: '提现金额必须为数字' }
            ]" autocomplete="off"></el-input>
                </el-form-item>
                <el-button type="primary" @click="toapply()" size="mini">确认金额</el-button>
            </el-form>
        </el-dialog>
            <el-card  >
              <el-col :span="3">
                  <el-button type="primary" size="mini" icon="plus" @click="getExport()">导出数据</el-button>
              </el-col>
                <el-table :data="dataList2" v-loading="loading2">
                    <el-table-column prop="created_at" label="日期"></el-table-column>
                    <el-table-column prop="pay_type_str" label="类型"></el-table-column>
                    <el-table-column label="交易金额">
                        <template slot-scope="scope">
                            {{(scope.row.amount/100).toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="当前余额">
                        <template slot-scope="scope">
                            {{(scope.row.now_amount/100).toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="交易前余额">
                        <template slot-scope="scope">
                            {{(scope.row.total_fee/100).toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.status == 0 ? 'info' : 'success'"> {{scope.row.status == 0 ? '失败'
                :'成功'}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="content-center content-top-padded" v-if="total_count2 > 1">
                    <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange2" @size-change="handleSizeChange2" :current-page.sync="params2.page" :page-sizes="[10, 20, 50]" :total="total_count2" :page-size="params2.pagesize">
                    </el-pagination>
                </div>
            </el-card>

    </div>
</div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import draggable from "vuedraggable";
import {
    getQueryReserveFundBalance,
    toApply,
    paybybacksms,
    getQueryMerchantBalance,
    getPlatformFeeList,
    getMerchantBalance

} from "../../../api/merchant";
export default {
    components: {
        draggable
    },
    data() {
        return {
        pickerOptions: {
            shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                }
            }]
        },
            dialogFormVisible: false,
            total_count: 0,
            total_count2: 0,
            params: {
                page: 1,
                pagesize: 10,
            },
            params2: {
                page: 1,
                pagesize: 10,
                is_platform:1,
            },
            dataList: [],
            dataList2: [],
            loading: false,
            loading2: false,
            id: "",
            row: [],
            queryArr: {},
            platformBalance: {},
            form: {
                amount: 1
            },
            newform: {
                bizOrderNo: '',
                verificationCode: ''
            },
            platformlist:{}
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
        },
        handleCurrentChange(page_num) {
            this.params.page = page_num;
            this.getPlatformFee();
        },
        searchData() {
            this.getQueryMerchantBalanceList(this.params);
        },
        handleSizeChange(pageSize) {
            this.params.page = 1;
            this.params.pagesize = pageSize;
            this.getPlatformFee();
        },
        getPlatformFee() {
            this.loading = true;
            getPlatformFeeList(this.params).then((res) => {
                if (res.data.data.total_count) {
                    this.dataList = res.data.data.list
                    this.total_count = res.data.data.total_count
                    this.loading = false;
                }

            })
        },
        handleCurrentChange2(page_num) {
            this.params2.page = page_num;
            this.getDataLists();
        },
        searchData2() {
            this.params2.page = 1;
            this.getDataLists();
        },
        handleSizeChange2(pageSize) {
            this.params2.page = 1;
            this.params2.pagesize = pageSize;
            this.getDataLists();
        },
        getDataLists() {
            this.loading2 = true;
            getMerchantBalance(this.params2)
                .then((response) => {
                    this.dataList2 = response.data.data.list;
                    this.total_count2 = response.data.data.total_count;
                    this.loading2 = false;
                })
                .catch((error) => {
                    this.loading2 = false;
                    this.$message({
                        type: "error",
                        message: "获取列表信息出错",
                    });
                });
        },
        getQueryMerchantBalanceData() {
            this.platformBalance = {
                allAmount: 0,
                freezeAmount: 0,
            }
            getQueryMerchantBalance().then((res) => {
                if (res.data.data.status == true) {
                    this.platformBalance = res.data.data.data
                }
            })
        },
        getQueryMerchantBalanceList(params) {
            getQueryMerchantBalance(params).then((res) => {
                if (res.data.data.status == true) {
                    this.platformlist = res.data.data.data
                }
            })
        },
        //余额查询
        getQueryBalance() {
            this.queryArr = {
                balance: 0
            }
            getQueryReserveFundBalance().then((res) => {
                if (res.data.data.status == true) {
                    this.queryArr = res.data.data.data
                }
            })
        },
        toapply() {
            this.$confirm('是否确认金额?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                toApply(this.form).then((res) => {
                    if (res.data.data.status == true) {
                        this.$message({
                            type: "success",
                            message: res.data.data.msg,
                        });
                        this.new.newform.bizOrderNo = res.data.data.data.bizOrderNo
                        this.params2.page = 1;
                        this.getDataLists();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.data.msg,
                        });
                    }

                })
            }).catch(() => {});

        },
        toSubmit() {
            this.$confirm('是否确认提现?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                paybybacksms(this.newform).then((res) => {
                    if (res.data.data.status == true) {
                        this.$message({
                            type: "success",
                            message: res.data.data.msg,
                        });
                        //刷新余额接口
                        this.getQueryMerchantBalanceData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.data.msg,
                        });
                    }
                })
            }).catch(() => {});

        },
    },
    mounted() {
        this.getQueryBalance();
        this.getQueryMerchantBalanceData();
        this.getPlatformFee();
        this.getDataLists();
    },
};
</script>

<style lang="scss" scoped>
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    img {
        width: 90%;
    }
}

.el-col {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// apply.vue?8828946e